import { CancelToken, COMMAND, Connection, ServerCommand } from "../connection.client";

export function aiStrategyTradesListenRequest(
    callback: (response: string) => void
): CancelToken {
    const messageToServer = [
        [COMMAND, "alerts_service_command"],
        ["subcommand", "ai_strategy_trades_subscribe"]
    ] as ServerCommand;

    return Connection.getInstance().sendWithStreamingResponse(messageToServer, callback);
}

export function aiStrategyTradesStopRequest(subscriptionId: string): void {
    const stopMessage = [
        [COMMAND, "alerts_service_command"],
        ["subcommand", "ai_strategy_trades_unsubscribe"],
        ["subscription_id", subscriptionId]
    ] as ServerCommand;

    Connection.getInstance().sendWithNoResponse(stopMessage);
}
